// const url = "http://35.162.202.5:5000";
// const url = "http://52.199.85.143:5000";
// const url = "http://52.199.85.143:5000";
const url = "https://www.davidellis.co.uk/api";
// const url = "http://localhost:5000";
export default url;